import React, { useEffect, useState } from "react";
import { TabsBase, ButtonBase } from "@reusejs/react";
import {
  getAllAuctionEvents,
  updateBidderForEvent,
  updateBidderOnboardingName,
  updateBidderOnboarding,
  getBidderOnboardingOfUser,
} from "services";
import PanVerificationForm from "./panVerificationForm";
import DocumentVerificationForm from "./documentVerificationForm";
import PanPreview from "./panPreview";
import DocumentPreview from "./documentPreview";
import { useRouter } from "next/router";
import NameMismatchModal from "./NameMismatchModal";
export default function KycForm(props: any) {
  const router = useRouter();
  const [kycData, setKycData] = useState<any>(null);
  const [modal, setModal] = useState<any>(false);
  const [changeName, setChangeName] = useState<any>(false);
  const [docType, setDocType] = useState<any>("");
  const [error_message, setError_message] = useState<any>("");

  console.log("bidder::>", props.data);

  // update bidder here and pass the call back to form
  const updateKycData = async (data: any) => {
    try {
      if (data?.pan_data?.verified) {
        let payload: any = props.data;
        payload["kyc_data"] = data;
        payload.kyc_verified = true;
        if (
          payload.kyc_verified &&
          payload.emd_amount_paid &&
          payload.agreement_signed &&
          payload.application_form_filled
        ) {
          payload["status"] = "verified";
        } else {
          payload["status"] = "pending";
        }
        const res: any = await updateBidderForEvent(payload);
        setKycData(res?.kyc_data);
      }
    } catch (error) {
      console.log("check error:", error);
    }
  };

  useEffect(() => {
    if (props.data?.kyc_data) {
      setKycData(props.data?.kyc_data);
    }
  }, [props.data]);

  const handleDocumentCallback = (data: any) => {
    if (data?.other_document_data?.name_validation?.status) {
      updateKycData(data);
    } else {
      let document_type = data?.other_document_data?.document_type;

      if (document_type === "aadhaar") setDocType("Adhaar Card");
      else if (document_type === "passport") setDocType("PassPort");
      else if (document_type === "voterid") setDocType("Voter ID");
      else if (document_type === "drivingLicence")
        setDocType("Driving License");

      setModal(true);
    }
  };

  const handlePANCallback = (data: any) => {
    if (data?.pan_data?.verified) {
      if (
        data?.pan_no_validation?.status &&
        data?.pan_name_validation?.status
      ) {
        updateKycData(data);
      } else if (!data?.pan_no_validation?.status) {
        setDocType("PAN");
        setError_message(data?.pan_no_validation?.message);
        setModal(true);
      } else if (!data?.pan_name_validation?.status) {
        setDocType("PAN_Warning");
        setError_message(data?.pan_name_validation?.message);
        setModal(true);
        updateKycData(data);
      }
    } else {
      setDocType("PAN");
      setError_message("Please provide Valid PAN Card");
      setModal(true);
    }
  };

  const handleChangeName = async () => {
    let bidderData: any;
    try {
      bidderData = await getBidderOnboardingOfUser(props?.data?.user_uuid);
      if (!bidderData?.uuid) {
        console.error("Bidder onboarding data not found");
        return;
      }
      bidderData["name"] =
        kycData?.pan_data?.signzy_response?.verification_data?.result?.upstreamName;
      const res: any = await updateBidderOnboardingName(bidderData);
      if (res) {
        let kycPayload = kycData;
        kycPayload["pan_name_validation"]["status"] = true;
        kycPayload["pan_name_validation"]["message"] = "";
        kycPayload["pan_name_validation"]["validation"] = "Validation success";

        const response = await updateKycData(kycPayload);
      }
    } catch (error) {
      console.log("check error:", error);
    }
  };

  return (
    <div className="mx-auto min-h-screen max-w-5xl border py-6 px-12 rounded-md">
      <div className="col-span-2 flex flex-col justify-center items-center">
        <h2 className="font-bold tracking-wide text-2xl">
          Verify your identities
        </h2>
        <p className="tracking-tighter pt-1 text-gray-400">
          Read the form carefully before proceeding
        </p>
      </div>
      {!kycData?.pan_data?.verified || !kycData?.pan_no_validation?.status ? (
        <PanVerificationForm
          callback={(data: any) => handlePANCallback(data)}
          {...props}
        />
      ) : (
        <PanPreview kycData={kycData} />
      )}

      {kycData?.pan_data?.verified &&
        kycData?.pan_no_validation?.status &&
        (!kycData?.other_document_data?.verified ||
        !kycData?.other_document_data?.name_validation?.status ? (
          <DocumentVerificationForm
            callback={(data: any) => handleDocumentCallback(data)}
            {...props}
          />
        ) : (
          <DocumentPreview kycData={kycData} />
        ))}

      <div className="flex justify-end text-center pt-2">
        <ButtonBase
          variant="primary"
          type="button"
          label={"Save & Submit"}
          onClick={() => router.push(`/kyc/${props.id}?step=${props.nextStep}`)}
          buttonBaseClasses={{
            font: "text-base font-medium",
            backgroundColor: "bg-green-600 hover:bg-green-700",
            textColor: "text-white",
            border: "any",
            padding: "px-4 py-2",
          }}
          disabled={
            !(
              props.data?.kyc_data?.pan_data?.verified &&
              (props.data?.kyc_data?.other_document_data?.verified ||
                props.data?.kyc_data?.other_document_data?.verified === "true")
            )
          }
          // busy={form.busy}
          // busyText={<Loader height="h-6" width="w-6" />}
        />
      </div>
      {modal && (
        <NameMismatchModal
          setModal={setModal}
          callback={handleChangeName}
          DocType={docType}
          message={error_message}
        />
      )}
    </div>
  );
}
